import { AxiosError, AxiosRequestHeaders } from 'axios';
import merge from 'lodash/merge';

export const makeAxiosError = (overrides?: Partial<AxiosError>): AxiosError => {
  const defaults: AxiosError<string> = {
    isAxiosError: false,
    toJSON: () => ({}),
    config: { headers: {} as AxiosRequestHeaders },
    name: '',
    message: '',
    response: {
      data: 'some-data',
      status: 400,
      statusText: '',
      headers: {},
      config: { headers: {} as AxiosRequestHeaders },
    },
  };

  return merge(defaults, overrides);
};

export const axiosErrorDefault = makeAxiosError();

export const axiosErrorNoResponse: AxiosError = {
  ...axiosErrorDefault,
  response: undefined,
};
